<template>
  <div class="productCenter">
     <header>
    <Navbar />
    </header>
    <div class="product-header">
      <div class="product_bannnerText">
        <div>支持与服务</div>
        <div>
          展华科技紧扣时代脉搏，持续走创新发展的道路，已经获得包括HIS、电子病历、集成平台、智慧医疗、综合运营管理、区域医疗等在内的数十项自主知识产权产品国家级认证。
        </div>
      </div>
    </div>
    <div class="productCont">
      <div class="pth">
        <div class="rerurn" @click="goProductCenter" >
          <div>返回上一级</div>
          <div class="returnLeve"><img :src="returnLeve" /></div>
        </div>
      </div>
      <div class="productTitle">
        <div>服务承诺</div>
        <div class="redline"></div>

        <div class="promise">
          <div>
            展华科技本着本着“客户为本，科技创新，产品与服务为纲”的原则，
          </div>
          <div>为用户提供“安全、可靠、高质量”的服务，</div>
          <div>我们的宗旨是“成为更好的数字医疗信息服务提供商”。</div>
          <div>在您使用我们的产品后，我们将为您做好一系列的配套服务安排，</div>
          <div>且及时响应您的服务请求。</div>
          <div>同时，我们也欢迎您监督我们的服务行为和服务质量。</div>
        </div>
        <div class="productText">
          <div class="promiseList">
            <img :src="SupandSera" />
            <div>科技</div>
          </div>
          <div class="promiseList">
            <img :src="SupandSerb" />
            <div>创新</div>
          </div>
          <div class="promiseList">
            <img :src="SupandSerc" />
            <div>产品</div>
          </div>
          <div class="promiseList">
            <img :src="SupandSerd" />
            <div>服务</div>
          </div>
        </div>
      </div>
    </div>
    <div class="productclassify">
      <div class="productTitle">
        <div>服务分类</div>
        <div class="redline"></div>
      </div>
      <div class="classify">
        <div class="classifyBox">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="软件服务应用" name="first">
              <div class="classifyCont">
                <div class="classifyTitle">软件服务应用</div>
                <div class="classifyText">
                  <li>
                    <span>信函、电话、传真咨询服务：</span
                    >利用信函、电话、传真等手段免费为用户解答有关软件购买、培训日程及方式、安装异常、操作异常、运行管理等问题。
                  </li>
                  <li>
                    <span>远程通讯服务：</span
                    >向用户提供电子邮件通讯或INTERNET软件下载服务。
                  </li>
                  <li>
                    <span>软件应用交流活动：</span
                    >定期组织用户之间、用户与软件开发人员之间技术交流活动。
                  </li>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="软件安装配置与运行维护服务" name="second">
              <div class="classifyCont">
                <div class="classifyTitle">软件安装配置与运行维护服务</div>
                <div class="classifyText">
                  <li>
                    <span>产品的支撑软件安装、设置：</span
                    >帮助用户完成相关支撑软件的安装与设置。
                  </li>
                  <li>
                    <span>安装与系统参数设置：</span
                    >帮助用户完成软件的安装与系统参数设置。
                  </li>
                  <li>
                    <span>软件常规运行维护服务：</span>提供软件运行维护服务。
                  </li>
                  <li>
                    <span>统一的用户管理，高效的单点登陆机制：</span
                    >构建一个综合的应用集成平台所需的基础。
                  </li>
                </div>
              </div></el-tab-pane
            >
            <el-tab-pane label="现场支持服务" name="third">
              <div class="classifyCont">
                <div class="classifyTitle">现场支持服务</div>
                <div class="classifyText">
                  <li>
                    <span
                      >为全国广大医疗卫生行业用户提供安全、可靠、高质量的医疗信息化产品和技术服务</span
                    >
                    <div class="trait">
                      我们拥有一支经验丰富的技术团队，以专业化软件技术为核心，他们可以面对面地与您进行沟通，在软件运行现场就您高校的具体问题进行针对性的研究分析，使问题迅速得到解决。
                    </div>
                  </li>
                </div>
              </div></el-tab-pane
            >
            <el-tab-pane label="实施服务" name="fourth">
              <div class="classifyCont">
                <div class="classifyTitle">实施服务</div>
                <div class="classifyText">
                  <li>
                    <span
                      >以医疗行业用户获得最佳的产品应用体验和持续发展为己任，力争创造客户、社会价值的最大化</span
                    >
                    <div class="trait">
                      实施服务是根据客户需求定制，满足客户个性化要求，为客户确定实施范围、实施任务任务、实施成果、项目计划、项目组织结构与人员职责、项目管理方法，并帮助客
                      户成功应用的专业服务。通过实施工程师，为用户提供满意的咨询实施应用服务，帮助用户成功，并为用户创造价值。
                    </div>
                  </li>
                </div>
              </div></el-tab-pane
            >
            <el-tab-pane label="售前咨询服务" name="fifth">
              <div class="classifyCont">
                <div class="classifyTitle">售前咨询服务</div>
                <div class="classifyText">
                 <li>
                    <span
                      >提供专业合理的售前咨询服务</span
                    >
                    <div class="trait">
                      根据客户的具体情况和信息化建设的需要，提供规划咨询及解决方案，帮助您做出快速、准确的决策；向用户提供软件应用过程中不明事项的指导和应用咨询。
                    </div>
                  </li>
                </div>
              </div></el-tab-pane
            >
          </el-tabs>
        </div>
      </div>
    </div>
     <footer>
    <Root/>
    </footer>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script src="//unpkg.com/element-ui@2.15.7/lib/index.js"></script>
<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue"
import SupandSera from "../../assets/SupandSera.png";
import SupandSerBanner from "../../assets/SupandSerBanner.png";
import SupandSerb from "../../assets/SupandSerb.png";
import SupandSerc from "../../assets/SupandSerc.png";
import SupandSerd from "../../assets/SupandSerd.png";
import classifyBanner from "../../assets/classifyBanner.png";
import returnLeve from "../../assets/returnLeve.png";
export default {
  name: "SupandSer",
   components: {
    Navbar,Root,
  },
  data() {
    return {
      activeName: "first",
      SupandSera: SupandSera,
      SupandSerBanner: SupandSerBanner,
      SupandSerb: SupandSerb,
      SupandSerc: SupandSerc,
      SupandSerd: SupandSerd,
      classifyBanner: classifyBanner,
       returnLeve: returnLeve,
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    run: function () {
      console.log("333");
    },
     goProductCenter() {
      this.$router.push({ path: "productCenter" });
    },
  },
};
</script>
<style scoped>
footer{
  height: 520px;
  margin-top: 30px;
}
header{
 background-color: #ffffff;
}
.returnLeve {
  margin-left: 10px;
}
.pth {
  margin-bottom: 30px;
  height: 22px;
 
}
.rerurn {
  cursor: pointer;
  position: absolute;
  right: 0;
  display: flex;
  height: 30px;
  font-size: 16px;
  color: #767b8d;
  letter-spacing: 0;
  text-align: right;
  font-weight: 400;
}
.product-header {
  position: relative;
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background: url("../../assets/SupandSerBanner.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.product_bannnerText {
  position: absolute;
  left: 7.5%;
  top: 113px;
}
.product_bannnerText :nth-child(1) {
  font-size: 52px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.product_bannnerText :nth-child(2) {
  width: 64%;
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 200;
  margin-top: 33px;
}
.productCont {
  width: 85%;
  position: relative;
  margin: 0 auto;
  margin-top: 30px;
  display: block;
}
.productTitle {
  text-align: center;
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
}
.redline {
  width: 60px;
  height: 6px;
  margin: 0 auto;
  margin-top: 20px;
  background-color: #e52f22;
}
.productText {
  margin-top: 100px;
  display: flex;
  justify-content: space-between;
}
.promiseList :nth-child(2) {
  font-size: 22px;
  color: #e52f22;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 20px;
}
.promise {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  margin-top: 50px;
}
.productclassify {
  margin-top: 100px;
}
.classify {
  background: url("../../assets/classifyBanner.png") no-repeat;
  background-size: cover;
  background-position: center;
}
.classifyBox {
  width: 85%;
  margin: 0 auto;
}
.classifyCont {
  width: 90%;
  margin: 0 auto;
  height: 269px;
  /* margin-bottom: 50px; */
}
.classifyTitle {
  font-size: 28px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 50px;
}
.classifyText {
  margin-top: 31px;
}
.trait {
  width: 96%;
  margin: 0 auto;
  margin-top:15px;
}
.classify li {
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  font-weight: 400;
  margin-bottom: 20px;
  line-height: 28px;
  font-family: PingFangSC-Regular;
}
.classify li span {
  font-size: 16px;
  color: #0f1422;
  letter-spacing: 0;
  text-align: justify;
  font-weight: 500;
}

.classify >>> .el-tabs__active-bar {
  background-color: #e52f22 !important;
  height: 3px;
}
.classify >>> .el-tabs__item.is-active {
  font-size: 18px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 400;
}
.classify >>> .el-tabs__item {
  font-size: 18px;
  color: #0f1422;
  letter-spacing: 0;
  font-weight: 400;
}
.classify >>> .el-tabs__item {
  padding: 0 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/SupandSer/index.vue